var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFailCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_1113_14293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.17538 0 0 7.17538 0 16C0 24.8246 7.17538 32 16 32C24.8246 32 32 24.8246 32 16C32 7.17538 24.8246 0 16 0Z",
    fill: "#F01A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7683 15.9997L22.5099 12.2581C22.7437 12.0243 22.8668 11.7166 22.8668 11.3843C22.8668 11.052 22.7314 10.7443 22.5099 10.5104L21.4883 9.48891C21.0083 9.00891 20.2329 9.00891 19.7529 9.48891L16.0114 13.2304L12.2699 9.48891C12.036 9.25506 11.7283 9.13198 11.396 9.13198C11.076 9.13198 10.756 9.26737 10.5222 9.48891L9.50063 10.5104C9.02063 10.9904 9.02063 11.7658 9.50063 12.2458L13.2422 15.9874L9.50063 19.7289C9.26678 19.9628 9.1437 20.2704 9.1437 20.6028C9.1437 20.9351 9.27909 21.2428 9.50063 21.4766L10.5222 22.4981C10.7683 22.7443 11.076 22.8551 11.396 22.8551C11.716 22.8551 12.0237 22.732 12.2699 22.4981L16.0114 18.7566L19.7529 22.4981C19.9868 22.732 20.2945 22.8551 20.6268 22.8551C20.9591 22.8551 21.2668 22.7197 21.5006 22.4981L22.5222 21.4766C23.0022 20.9966 23.0022 20.2212 22.5222 19.7412L18.7806 15.9997H18.7683Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1113_14293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFailCircle);
export default __webpack_public_path__ + "static/media/ico-fail-circle.032dedd08f0c99050f9eff72a47f6cd2.svg";
export { ForwardRef as ReactComponent };